<template><section><h2>Nightingale Rose Chart 南丁格尔图</h2>
<block-demo tip="" source="const data = [
  { value: 6100, label: &quot;TOP1&quot; },
  { value: 5200, label: &quot;TOP2&quot; },
  { value: 4400, label: &quot;TOP3&quot; },
  { value: 3700, label: &quot;TOP4&quot; },
  { value: 2800, label: &quot;TOP5&quot; },
  { value: 3000, label: &quot;TOP6&quot; },
  { value: 5300, label: &quot;TOP7&quot; },
  { value: 3400, label: &quot;TOP8&quot; },
]
const { Chart, PolarBar, Tooltip } = qcharts
const chart = new Chart({
  container: &quot;#app&quot;,
})
chart.source(data, {
  value: &quot;value&quot;,
  text: &quot;label&quot;,
})
const bar = new PolarBar({
  innerRadius: 0.1,
  radius: 0.8,
})
const tooltip = new Tooltip()
chart.append([bar, tooltip])
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [
  { <span class="hljs-attr">value</span>: <span class="hljs-number">6100</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"TOP1"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">5200</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"TOP2"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">4400</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"TOP3"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">3700</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"TOP4"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">2800</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"TOP5"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">3000</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"TOP6"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">5300</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"TOP7"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">3400</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"TOP8"</span> },
]
<span class="hljs-keyword">const</span> { Chart, PolarBar, Tooltip } = qcharts
<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({
  <span class="hljs-attr">container</span>: <span class="hljs-string">"#app"</span>,
})
chart.source(data, {
  <span class="hljs-attr">value</span>: <span class="hljs-string">"value"</span>,
  <span class="hljs-attr">text</span>: <span class="hljs-string">"label"</span>,
})
<span class="hljs-keyword">const</span> bar = <span class="hljs-keyword">new</span> PolarBar({
  <span class="hljs-attr">innerRadius</span>: <span class="hljs-number">0.1</span>,
  <span class="hljs-attr">radius</span>: <span class="hljs-number">0.8</span>,
})
<span class="hljs-keyword">const</span> tooltip = <span class="hljs-keyword">new</span> Tooltip()
chart.append([bar, tooltip])
</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>